const {
  BASE_URL,
  VUE_APP_AUTH_URL: AUTH_URL,
} = process.env;

const TOKEN_KEY = 'token';
const COOKIE_TOKEN = 'user_token';
const COOKIE_CONSENT_TOKEN = 'cookie-consent';

const SECONDS_BEFORE_EXPIRE = 5 * 60;

export {
  BASE_URL,
  AUTH_URL,
  TOKEN_KEY,
  COOKIE_TOKEN,
  SECONDS_BEFORE_EXPIRE,
  COOKIE_CONSENT_TOKEN,
};
